import { For } from "solid-js";
import { useActiveSection } from "~/hooks/useActiveSection";
import { useI18n } from "~/i18n";
import type { TranslationKey } from "~/i18n/translations";

const SECTIONS: { id: string; label: TranslationKey }[] = [
  { id: "live-session", label: "marketing.features.nav.live" },
  { id: "proactive-intelligence", label: "marketing.features.nav.proactive" },
  { id: "auto-apply-tags", label: "marketing.features.nav.tags" },
  { id: "speakers", label: "marketing.features.nav.speakers" },
  { id: "after-the-meeting", label: "marketing.features.nav.after" },
  { id: "integrations", label: "marketing.features.nav.integrations" },
  { id: "memory", label: "marketing.features.nav.memory" },
  { id: "automation", label: "marketing.features.nav.automation" },
  { id: "trust", label: "marketing.features.nav.trust" },
];

/** The page's anchors, pinned under the header on desktop with the current section marked. */
export const SectionNav = () => {
  const { t } = useI18n();
  const active = useActiveSection(SECTIONS.map((section) => section.id));
  return (
    <nav
      aria-label={t("marketing.features.nav.label")}
      class="z-30 border-y border-primary-border bg-canvas/85 backdrop-blur-md lg:sticky lg:top-16"
    >
      <ol class="mx-auto flex max-w-7xl gap-1 overflow-x-auto px-4 py-2 sm:px-6 lg:justify-center lg:px-8">
        <For each={SECTIONS}>
          {(section, i) => (
            <li class="shrink-0">
              <a
                href={`#${section.id}`}
                aria-current={active() === section.id ? "location" : undefined}
                class="flex items-center gap-2 rounded-lg px-3 py-2 text-sm font-medium whitespace-nowrap text-secondary-text transition-colors hover:bg-panel hover:text-primary-text focus-visible:ring-2 focus-visible:ring-brand focus-visible:outline-none aria-[current]:bg-panel aria-[current]:text-primary-text"
              >
                <span class="font-mono text-[11px] text-muted-text">{String(i() + 1).padStart(2, "0")}</span>
                {t(section.label)}
              </a>
            </li>
          )}
        </For>
      </ol>
    </nav>
  );
};
